export const callPredictionApi = async payload => {
  try {
    const url =
      process.env.REACT_APP_NODE_ENV === 'prod'
        ? 'https://4pu12usvo9.execute-api.us-east-1.amazonaws.com/prod/mission/predict_cvr'
        : 'https://tn5zxp3j86.execute-api.us-east-1.amazonaws.com/dev/mission/predict_cvr'

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    return await response.json()
  } catch (error) {
    console.error('Error calling prediction API', error)
    return null
  }
}
